<template>
  <div class="ai-box">
    <div class="ai-top">
      <div class="left">
        <span style="display: inline-block;vertical-align:bottom;"><img style="width: 24px;height: 24px;"
                                                                        :src="aiIcon"/></span>
        <span style="margin-left: 10px;">{{ $t('ai.title') }}</span>
        <span style="display: inline-flex;justify-content: center;align-items: center">
          <span
              style="font-weight: 400;font-size: 13px;color: rgba(0,0,0,0.65);line-height: 12px;margin-left: 10px;">
            {{ $t('ai.point.title.text') }}
            <span style="color: red;cursor: pointer;text-decoration: underline" @click="toBuy">
              {{ userDataInformation?.freeAiNum ? userDataInformation?.freeAiNum : 0 }}
              {{ $t('common_ph24') }}
            </span>
          </span>
             <el-popover
                 :content="$t('ai.point.tips')"
                 placement="bottom"
                 effect="dark"
             >
            <template #reference>
               <el-icon style="color: #969696; margin-left: 4px;"><QuestionFilled/></el-icon>
            </template>
          </el-popover>
          <!--          <el-button link type="primary" size="small" style="text-decoration: underline;display: inline-block"-->
          <!--                     >-->
          <!--            {{ $t("write.to.buy.group.email") }}-->
          <!--          </el-button>-->
        </span>
      </div>
      <div class="right">
        <!--        <img class="img" @click="handleClickSetting" src="@/assets/AI/setting.png"/>-->
        <img class="img" @click="handleClickHistory" src="@/assets/AI/history.png"/>
        <img class="img" @click="handleCloseAIChat" src="@/assets/AI/right-row.png"/>
      </div>
    </div>
    <div class="chat-content" ref="messageContainer" @scroll="handleClickScroll">
      <template v-if="isFirstOpen">
        <template v-if="!enterDetailLoading">
          <template v-for="(item,index) in chatContentArray" :key="item">
            <ChatAI :item="item" @refresh="handleClickReplay"
                    :chatContentArray="chatContentArray"
                    @closeCopy="handleCloseAIChat"
                    :isSelectModel="isSelectModel"
            >
              <!-- 判断是否展示 createTime -->
              <template #time v-if="shouldShowCreateTime(index)">
                <div class="time">
                  {{ item.createTime }}
                </div>
              </template>
            </ChatAI>
          </template>
        </template>
        <template v-else>
          <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
            <div v-loading="enterDetailLoading"></div>
          </div>
        </template>
      </template>
      <template v-else>
        <div
            style="width: 100%;height: 100%;padding: 40px;display: flex;justify-content: center;flex-direction: column;align-items: center">
          <div style="margin-bottom: 15px">
            <img
                style="height: 60px; width: 60px"
                src="@/assets/chat.png"
                class="icon"
            />
          </div>
          <div class="btn-text-ai">{{ $t('common.ai.hi') }}</div>
          <div class="btn-text-ai">{{ $t('common.ai.des') }}</div>
        </div>
      </template>
    </div>
    <div style="display: flex;flex-direction: column;">
      <!--      重复： {{ preAIChatData }}-->
      <!--      所有： {{ chatContentArray }}-->
      <div v-if="isFirstOpen" class="ai-tools">
        <div style="display: flex;justify-content: space-between">
          <el-button type="info" :class="['btn-tool',isSelectModel?'select_r1':'unselect_r1']" round
                     @click="handleClickChangeModel">
            <template #icon>
              <img src="@/assets/AI/sdsk.svg" style="width: 16px;height: 16px;margin-right: 10px">
            </template>
            <span style="font-size: 13px !important;">{{ $t('common.deep.think') }}</span>
          </el-button>
          <el-button type="info" class="btn-tool" round @click="handleClickFixMistakes">
            <template #icon>
              <img src="@/assets/AI/change-error.png" style="width: 16px;height: 16px">
            </template>
            <span style="font-size: 13px !important;">{{ $t('common.lang.current.error') }}</span>
          </el-button>
          <el-button type="info" class="btn-tool" round @click="handleClickReplay('')">
            <template #icon>
              <img src="@/assets/AI/refresh.png" style="width: 16px;height: 16px">
            </template>
            <span style="font-size: 13px !important;">{{ $t('common.repeat.answer') }}</span>
          </el-button>
        </div>
        <div style="margin-top: 10px;display: flex;justify-content: space-between">
          <el-select v-model="valueText"
                     :placeholder="$t('common.ai.text')"
                     :teleported="false"
                     class="btn-tool-sp"
                     default-first-option
                     @change="handleClickChangeSelect"
          >
            <template #prefix>
              <img class="tag_img" src="@/assets/AI/text.png"/>
            </template>
            <el-option
                v-for="item in optionsText"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
              <div style="display: flex;align-items: center;flex-direction: row">
                <!--                <img class="tag_img" style="margin-right: 6px;display: block" src="@/assets/AI/text.png"/>-->
                <div>{{ item.label }}</div>
              </div>
            </el-option>
          </el-select>
          <el-select v-model="valueTone"
                     :placeholder="$t('common.ai.tone')"
                     :teleported="false"
                     class="btn-tool-sp"
                     default-first-option
                     @change="handleClickChangeSelect"
          >
            <template #prefix>
              <img class="tag_img" src="@/assets/AI/say.png"/>
            </template>
            <el-option
                v-for="item in optionsTone"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
              <div style="display: flex;align-items: center;flex-direction: row;">
                <!--                <img class="tag_img" style="margin-right: 6px;display: block" src="@/assets/AI/say.png"/>-->
                <span>{{ item.label }}</span>
              </div>
            </el-option>
          </el-select>
          <el-select v-model="valueLang" :placeholder="$t('common.ai.lang')" :teleported="false" class="btn-tool-sp"
                     @change="handleClickChangeSelect"
          >
            <template #prefix>
              <img class="tag_img" src="@/assets/AI/lang.png"/>
            </template>
            <el-option
                v-for="item in optionsLang"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
              <div style="display: flex;align-items: center;flex-direction: row">
                <!--                <img class="tag_img" style="margin-right: 6px;display: block" src="@/assets/AI/lang.png"/>-->
                <span>{{ item.label }}</span>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-else class="ai-template-text">
        <el-button v-for="item in templateText" :key="item.key" type="info" class="btn-text" round
                   @click="handleClickText(item.value)">
          {{ item.value }}
        </el-button>
      </div>
      <div class="ai-text">
        <el-input
            v-model="chatText"
            style="width: 100%;resize:none"
            :placeholder="$t('common.ai.please.holder')"
            show-word-limit
            maxlength="3000"
            type="textarea"
            rows="4"
            @keydown.enter="handleEnter"
        />
        <!--        @keydown.enter.prevent="handleClickSend(true)"-->
        <div class="btn">
          <div
              :aria-disabled="chatText === '' ? true : false"
              v-if="currentIsCompleted"
              @click="chatText !== '' && handleClickSend(true)"
              :style="{ cursor: chatText === '' ? 'not-allowed' : 'pointer', opacity: chatText === '' ? 0.5 : 1 }"
          >
            <span style="font-size: 12px !important;">{{ $t('common.sent') }}</span>
          </div>
          <div
              v-else
              @click="handleClickStop"
          >
            <span style="font-size: 12px !important;">{{ $t('common.ai.stop') }}</span>
          </div>
          <el-button v-if="!isFirstOpen" type="info" :class="['btn-tool',isSelectModel?'select_r1_sp':'unselect_r1_sp']"
                     round
                     @click="handleClickChangeModel">
            <template #icon>
              <img src="@/assets/AI/sdsk.svg" style="width: 16px;height: 16px;margin-right: 10px">
            </template>
            <span style="font-size: 12px !important;">{{ $t('common.deep.think') }}</span>
          </el-button>
          <div v-if="isFirstOpen" @click="handleClickClose">
            <span style="font-size: 12px !important;">{{ $t('common.ai.save.create') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <HistoryChat v-if="visitableHistory" v-model="visitableHistory" @close="close"
               @detail="handleClickDetail"></HistoryChat>
  <DetailHistory v-if="visitableHistoryDetail" v-model="visitableHistoryDetail"
                 @close="closeDetail"></DetailHistory>
  <SettingAI v-if="visitableSetting" v-model="visitableSetting" @close="closeSetting"></SettingAI>
  <AIPointsWarningPop v-if="visitableAI" v-model="visitableAI" @close="visitableAIClose"></AIPointsWarningPop>
</template>
<script setup>
import {computed, nextTick, onMounted, reactive, ref, watch} from "vue";
import ChatAI from "@/components/AI/ChatAI.vue";
import Client from "@/components/AI/Client.vue";
import HistoryChat from "@/components/DiaPops/AI/HistoryChat.vue";
import DetailHistory from "@/components/DiaPops/AI/DetailHistory.vue";
import SettingAI from "@/components/DiaPops/AI/SettingAI.vue";
import {useStore} from "vuex";
import SSESdk from '@/api/sse'
import ChatAIArray from "@/components/AI/ChatAIArray.vue";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash";
import {isOpenLimit, TIME_OUT} from "@/utils/statusParams";
import dayjs from "dayjs";
import {processChatData} from "@/utils/util";
import {ElMessage} from "element-plus";
import AIPointsWarningPop from "@/components/DiaPops/AIPointsWarningPop.vue";
import {useRouter} from "vue-router";
import {i18n} from "@/lang";
import aiIcon from "@/assets/AI/AI@2x.png"

const emit = defineEmits(["closeAIChat"])
const store = useStore()
const router = useRouter()
// 模型选择
const isSelectModel = ref(false)

const currentTime = ref(dayjs(new Date()).format('HH:mm:ss'));
const chatText = ref("")
// 对话初始框
const isFirstOpen = ref(false)
// 滚动到底部函数
const messageContainer = ref()
// 聊天的内容
const chatContentArray = computed(() => store.state.AI.chatContentArray)

// 展示时间
const shouldShowCreateTime = (index) => {
  // 第一个 item 始终展示
  if (index === 0) return true;

  // 当前项与前一项的 createTime 比较，不同则展示
  return chatContentArray.value[index].createTime !== chatContentArray.value[index - 1].createTime;
};


const visitableAI = ref(false)
const visitableAIClose = () => {
  visitableAI.value = false
}

const valueText = ref('')
const valueTone = ref('')
const valueLang = ref('')

const optionsText = [
  {
    value: i18n.global.t('common.option.text.value1'),
    label: i18n.global.t('common.option.text.label1'),
  },
  {
    value: i18n.global.t('common.option.text.value2'),
    label: i18n.global.t('common.option.text.label2'),
  },
]
const optionsTone = [
  {
    value: i18n.global.t('common.option.tone.value.1'),
    label: i18n.global.t('common.option.tone.label.1'),
  },
  {
    value: i18n.global.t('common.option.tone.value.2'),
    label: i18n.global.t('common.option.tone.label.2'),
  },
  {
    value: i18n.global.t('common.option.tone.value.3'),
    label: i18n.global.t('common.option.tone.label.3'),
  },
  {
    value: i18n.global.t('common.option.tone.value.4'),
    label: i18n.global.t('common.option.tone.label.4'),
  },
  {
    value: i18n.global.t('common.option.tone.value.5'),
    label: i18n.global.t('common.option.tone.label.5'),
  },
  {
    value: i18n.global.t('common.option.tone.value.6'),
    label: i18n.global.t('common.option.tone.label.6'),
  },
  {
    value: i18n.global.t('common.option.tone.value.7'),
    label: i18n.global.t('common.option.tone.label.7'),
  },
  {
    value: i18n.global.t('common.option.tone.value.8'),
    label: i18n.global.t('common.option.tone.label.8'),
  },
]

const optionsLang = [
  {
    value: i18n.global.t('common.option.lang.value.1'),
    label: i18n.global.t('common.option.lang.label.1'),
  },
  {
    value: i18n.global.t('common.option.lang.value.2'),
    label: i18n.global.t('common.option.lang.label.2'),
  },
  {
    value: i18n.global.t('common.option.lang.value.3'),
    label: i18n.global.t('common.option.lang.label.3'),
  },
  {
    value: i18n.global.t('common.option.lang.value.4'),
    label: i18n.global.t('common.option.lang.label.4'),
  },
  {
    value: i18n.global.t('common.option.lang.value.5'),
    label: i18n.global.t('common.option.lang.label.5'),
  },
  {
    value: i18n.global.t('common.option.lang.value.6'),
    label: i18n.global.t('common.option.lang.label.6'),
  },
  {
    value: i18n.global.t('common.option.lang.value.7'),
    label: i18n.global.t('common.option.lang.label.7'),
  }
]

const templateText = ref([
  {key: 1, value: i18n.global.t('common.ai.template.text1')},
  {key: 2, value: i18n.global.t('common.ai.template.text2')},
  {key: 3, value: i18n.global.t('common.ai.template.text3')},
  {key: 4, value: i18n.global.t('common.ai.template.text4')}
])

// 聊天历史记录
const visitableHistory = ref(false)
const visitableHistoryDetail = ref(false)
const visitableSetting = ref(false)
// AI 思考
const isLoadingAIChat = ref(false)
// AI 当前思考是否完成
const isCompletedAIChat = ref(false)
// 记录当前会话重新生成 内容的所有数据
let preAIChatData = ref([])
// 用户是否进行手动滚动
const isUserScrolling = ref(false);
// 发送数据
const associateId = computed(() => store.state.AI.associateId)
// 详情数据
const currentTargetChat = computed(() => store.state.AI.currentTargetChat)
// 最后一条新的数据 root
const currentLastNewChat = computed(() => store.state.AI.currentLastNewChat)

// 展示时间
const isShowTime = ref(false)
const handleClickHistory = () => {
  visitableHistory.value = true
}
const close = () => {
  visitableHistory.value = false
}

const closeDetail = () => {
  visitableHistoryDetail.value = false
}

const handleEnter = (event) => {
  if (event.shiftKey) {
    // 允许换行
    return;
  }
  event.preventDefault();
  handleClickSend(true);
};


// 选中的item 详情详
const handleTargetDetail = ref({})
const enterDetailLoading = ref(false)
const handleClickDetail = async (item) => {
  console.log(item, 'item')
  if (!currentIsCompleted.value) {
    ElMessage.warning(i18n.global.t('common.ai.data.message'))
    return
  }
  // 先关闭
  isFirstOpen.value = true
  visitableHistoryDetail.value = false
  await close()
  enterDetailLoading.value = true
  //再进加载数据
  currentIsCompleted.value = true
  handleTargetDetail.value = item
  // 重置 分页缓存的数据
  await localStorage.setItem("pageData", JSON.stringify([]))
  // 重置 列表内容
  await store.commit("AI/setChatContentArray", [])
  await store.commit("AI/setAssociateId", "")
  isShowTime.value = true
  currentTime.value = item.createTime
  await store.dispatch("AI/queryChatByIdApis", {associateId: item.id, parentId: item.parentId ? item.parentId : '0'})
  //  将数据整理到 聊天框
  const res = currentTargetChat.value.map(item => ({
    ...item,
    isCompletedAIChat: true,
    associateContent: item.associateContent.split('\n\n').join('\n\n>')
  }))
  await store.commit("AI/setChatContentArray", res)
  await store.commit("AI/setAssociateId", item.id)
  // 第一次进入 检查缓存
  const result = localStorage.getItem("AIChat");
  console.log(result, 'result')
  if (!result || result === "null" || result === "undefined" || result === "") {
    const target = {
      associateId: item.id,
      model: isSelectModel.value ? 'deepseek-reasoner' : 'deepseek-chat',
      message: item.question,
      parentId: "0",
    }
    await localStorage.setItem("AIChat", JSON.stringify(target))
  }

  enterDetailLoading.value = false
  // 滚动到最底部
  await nextTick(() => {
    scrollToBottom();
  });
}

const closeSetting = () => {
  visitableSetting.value = false
}

const handleClickSetting = () => {
  visitableSetting.value = true
}

// 本次生成是否完毕？
const currentIsCompleted = ref(true)

// 判断容器是否在底部
const isAtBottom = () => {
  if (!messageContainer.value) return false;
  const {scrollTop, clientHeight, scrollHeight} = messageContainer.value;
  console.log(scrollTop + clientHeight, scrollHeight, ((scrollTop + clientHeight) - scrollHeight), scrollTop + clientHeight >= scrollHeight - 10, 'dddddd')
  return scrollTop + clientHeight >= scrollHeight - 10; // 允许少量误差
};

const allProductList = computed(() => store.state.buystorage.allProductList)
onMounted(async () => {
  if (isEmpty(allProductList.value)) {
    await store.dispatch("buystorage/getMailProductListApis", 1)
  }
})

// 存储 sse 对象
const sseClient = ref(null)

async function createSSE(params, item) {
  isCompletedAIChat.value = false;
  const baseUrl = process.env.VUE_APP_BASE_API + '/ai/chat/send';
  const queryString = Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

  const SSE = new SSESdk(`${baseUrl}?${queryString}`);
  sseClient.value = SSE;

  try {
    // 订阅来自服务端的消息
    await sseClient.value.start("message", async (data) => {
      isLoadingAIChat.value = false;

      const resultData = data.reasoningContent ? {type: 'reasoning', value: data.reasoningContent}
          : data.content ? {type: 'content', value: data.content}
              : null;
      if (resultData) {
        if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
          console.log("======p1=======")
          // 重复发送需要先 拼接，然后 获取 详情得到指定分页内容
          const resultPayload = chatContentArray.value.map(it => {
            console.log(it, item, it.id === item.id, 'dddddd')
            if (it.id === item.id) {
              let content = it.content
              let associateContent = it.associateContent
              if (resultData.type === 'reasoning') {
                resultData.value = resultData.value.split('\n\n').join('\n\n>');
                associateContent += resultData.value
              }
              if (resultData.type === 'content') {
                content += resultData.value
              }
              console.log(content, associateContent, 'resultPayload')
              return {
                ...it,
                question: item.question,
                parentAreaCount: parentAreaCountTotal.value,
                isCompletedAIChat: false,
                content: content,
                associateContent: associateContent,
                currentTime: currentTime.value
              }
            } else {
              return it
            }
          })
          // console.log(resultPayload, 'resultPayload')
          // const endResult = resultPayload.map(i => {
          //   if (i.id === item.id) {
          //     return {
          //       ...i,
          //       isCompletedAIChat: true
          //     }
          //   } else {
          //     return {...i}
          //   }
          // })
          // console.log(endResult, 'endResult')
          store.commit("AI/setChatContentArray", resultPayload)
        } else {
          // 非重复发送
          console.log("======p2=======")
          const lastMessage = chatContentArray.value[chatContentArray.value.length - 1];
          if (preAIChatData.value.length === 0) {
            if (resultData.type === 'reasoning') {
              // 实时拼接过程中检测 \n\n，插入 '>'
              resultData.value = resultData.value.split('\n\n').join('\n\n>');
              lastMessage.associateContent = (lastMessage.associateContent || '') + resultData.value;
            }

            if (resultData.type === 'content') {
              lastMessage.content = (lastMessage.content || '') + resultData.value;
            }
          } else {
            const lastContent = chatContentArray.value[chatContentArray.value.length - 1].content;
            const lastContentItem = lastContent[lastContent.length - 1];

            if (resultData.type === 'reasoning') {
              resultData.value = resultData.value.split('\n\n').join('\n\n>');
              lastContentItem.associateContent = (lastContentItem.associateContent || '') + resultData.value;
            }

            if (resultData.type === 'content') {
              lastContentItem.content = (lastContentItem.content || '') + resultData.value;
            }
          }
          await nextTick(() => {
            if (!isUserScrolling.value) {
              scrollToBottom();
            }
          });
        }
      }
    });
    // 等待订阅完成，检查 isCompleted 状态
    await new Promise((resolve, reject) => {
      const checkCompletion = setInterval(() => {
        if (sseClient.value.isCompleted) {
          clearInterval(checkCompletion);
          resolve();
        }
      }, 100);
      // 设置超时防止无限等待
      setTimeout(() => {
        clearInterval(checkCompletion);
        reject(new Error(i18n.global.t('common.ai.computed.timeout')));
      }, 300 * 1000); // 超时 5分钟
    });
  } catch (error) {
    console.log("SSE 连接或处理过程中发生错误:", 'ddddd');
    const result = JSON.parse(localStorage.getItem("AIChat"));
    let payload = {}
    if (item && item.parentId) {
      payload = {parentId: item.parentId}
      await store.dispatch("AI/getChatDetailListApisParent", payload);
      if (item && item.id) {
        const resultPayload = chatContentArray.value.map(it => {
          if (it.id === item.id) {
            return {
              ...chatDetailListParent.value[0],
              question: result.message,
              parentAreaCount: parentAreaCountTotal.value,
              isCompletedAIChat: true,
              content: i18n.global.t('common.ai.sse.message.error'),
              associateContent: "",
            }
          } else {
            return it
          }
        })
        await store.commit("AI/setChatContentArray", resultPayload)
      }
    } else {
      chatContentArray.value[chatContentArray.value.length - 1] = {
        ...chatDetailListParent.value[0],
        question: result.message,
        parentAreaCount: parentAreaCountTotal.value,
        isCompletedAIChat: true,
        content: i18n.global.t('common.ai.sse.message.error'),
        associateContent: "",
      }
    }
    currentIsCompleted.value = sseClient.value.isCompleted;
    console.log(sseClient.value.isCompleted, 'after completion check');
    isCompletedAIChat.value = true; // 遇到错误时，标记为已完成
  } finally {
    // 更新智能点数数据
    store.dispatch("cloud/queryByUserIdApis");
    if (isStopSSe.value) {
      isStopSSe.value = false
      return
    }
    // 获取详情 并替换 前端数据
    const result = JSON.parse(localStorage.getItem("AIChat"));
    const messageId = localStorage.getItem("messageId")
    const parentId = item && item.id ? item.id : messageId
    // payload = {parentId: parentId}
    // console.log(payload, 'payload')
    if (item && item.id) {
      // 如果是重新生成的内容则需要获取详情
      const resultPayload = chatContentArray.value.map(it => {
        if (it.id === item.id) {
          return {
            ...it,
            question: result.message,
            isCompletedAIChat: false,
            currentTime: currentTime.value
          }
        } else {
          return it
        }
      })
      await store.commit("AI/setChatContentArray", resultPayload)
    } else {
      chatContentArray.value[chatContentArray.value.length - 1].isCompletedAIChat = false
      // 保证 id 一直为 根的id
      chatContentArray.value[chatContentArray.value.length - 1].id = chatContentArray.value[chatContentArray.value.length - 1].id ? chatContentArray.value[chatContentArray.value.length - 1].id : parentId
    }

    //======= 确保最终状态同步 ========
    await store.dispatch("AI/getRootDataApis", {associateId: associateId.value})

    const targetResult = chatContentArray.value.map(i => {
      if (i.id === currentLastNewChat.value.id) {
        // store.commit("AI/setCurrentPage", currentLastNewChat.value.childCount + 1)
        return {
          ...currentLastNewChat.value,
          associateContent: currentLastNewChat.value.associateContent.split('\n\n').join('\n\n>'),
          isCompletedAIChat: true,
          isDetail: true,
        }
      } else {
        return {...i}
      }
    })
    await store.commit("AI/setChatContentArray", targetResult)
    console.log(chatContentArray.value, 'chatContentArray.value')
    // else {
    //   chatContentArray.value[chatContentArray.value.length - 1] = {
    //     ...chatDetailListParent.value[0],
    //     question: result.message,
    //     parentAreaCount: parentAreaCountTotal.value,
    //     isCompletedAIChat: true,
    //     content: chatDetailListParent.value[0]?.conversation,
    //     associateContent: "",
    //   }
    // }
    // tools 的添加会导致 页面 scroll 高度发生变化，需要继续滚动
    await nextTick(() => {
      if (!isUserScrolling.value) {
        scrollToBottom();
      }
    });
    currentIsCompleted.value = sseClient.value.isCompleted;
    // 展示完毕后，需要获取详情替换数据
    console.log(sseClient.value.isCompleted, 'after completion check');
  }
}

const scrollToBottom = () => {
  if (messageContainer.value) {
    if (!messageContainer.value || isUserScrolling.value) return;
    messageContainer.value.scrollTop = messageContainer.value.scrollHeight - 10;
  }
};

const payload = ref({})
const chatDetailList = computed(() => store.state.AI.chatDetailList)
const chatDetailListParent = computed(() => store.state.AI.chatDetailListParent)
// 文件存储的空间大小
const spaceSize = computed(() => store.state.cloud.spaceSize)
const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const handleClickSend = throttle(async (replay, item) => {
  return new Promise(async (resolve) => {
    console.log(currentIsCompleted.value, 'currentIsCompleteddddddddd', item)
    // 判断 AI 点数 是否收到充足
    if (isOpenLimit) {
      if (spaceSize.value?.freeAiNum >= 0) {
      } else {
        visitableAI.value = true
        return
      }
    }

    if (!currentIsCompleted.value) {
      resolve(); // 直接结束，如果没有完成
      return;
    }
    currentIsCompleted.value = false;
    if (replay) {
      isShowTime.value = true;
      preAIChatData.value = [];
    }

    // 检查是否需要创建新会话
    if (associateId.value === "") {
      await store.dispatch("AI/createSessionApis");
    }

    const messageId = localStorage.getItem("messageId");
    // sse 数据流
    if (replay) {
      currentItem.value = null
      // 不刷新AI内容
      payload.value = {
        associateId: associateId.value || item.associateId,
        model: isSelectModel.value ? 'deepseek-reasoner' : 'deepseek-chat',
        message: chatText.value,
        parentId: 0,
      };
    } else {
      // 刷新AI内容
      const result = JSON.parse(localStorage.getItem("AIChat"));
      if (result) {
        result.parentId = item && item.id ? item.id : messageId;
        payload.value = result;
        if (item || item && item.id) {
          payload.value.message = item.question;
        }
      } else {
        console.log('第一次进入')
      }
    }

    // 发起sse请求
    createSSE(payload.value, item);

    isFirstOpen.value = true;
    isLoadingAIChat.value = true;
    // 存储指定数据方便再次提交查询
    // if (!isSettingTool.value) {
    await localStorage.setItem("AIChat", JSON.stringify(payload.value));
    // }
    if (replay) {
      // 开启自动滚动
      isUserScrolling.value = false
      // 普通AI 回复组件
      chatContentArray.value.push({
        question: chatText.value,
        content: "",
        parentId: "0",
        associateContent: "",
        isCompletedAIChat: false,
        currentTime: currentTime.value
      });
      // 重置数据前需要将
      localStorage.setItem("messageId", "0");
    }
    // 清空展示数据
    chatText.value = "";
    await nextTick(() => {
      scrollToBottom();
    });
    resolve(); // 完成时触发 resolve，表示 handleClickSend 执行完毕
  });
}, TIME_OUT);

const parentAreaCountTotal = computed(() => store.state.AI.chatDetailListSettingParent.total)
// 点击重新生成的内容
const currentItem = ref(null)
const handleClickReplay = async (item) => {
  if (!currentIsCompleted.value) {
    return
  }
  console.log(item, 'item')

  // 这里需要缓存第一条数据
  const res = JSON.parse(localStorage.getItem("pageData"))
  if (res && res.length > 0) {
    const flag = res.filter(i => i.id === item.id).length
    if (flag >= 1) {
      // 存在
    } else {
      // 不存在
      localStorage.setItem("pageData", JSON.stringify([...res, item]))
    }
  } else {
    localStorage.setItem("pageData", JSON.stringify([item]))
  }

  if (typeof item === 'object' && item !== null && !Array.isArray(item)) {
    console.log('re-start-1')
    item.content = "";
    item.associateContent = "";
    currentItem.value = item
    await handleClickSend(false, item)
  } else {
    console.log('re-start-2')
    isUserScrolling.value = false
    isSettingTool.value = true;
    chatText.value = i18n.global.t('common.chat.text.repeat');
    await handleClickSend(true);
    isSettingTool.value = false;
    chatText.value = "";
  }
}


// 选择模版
const handleClickText = (value) => {
  chatText.value = value + '：';
}


// 结束并保存
const handleClickClose = async (val) => {
  if (!currentIsCompleted.value) {
    return
  }
  currentIsCompleted.value = true
  await store.commit("AI/setChatContentArray", [])
  await store.commit("AI/setAssociateId", "")
  valueTone.value = "";
  valueText.value = "";
  valueLang.value = "";
  isSelectModel.value = false;
  isFirstOpen.value = false
  isShowTime.value = false
  // emit("closeAIChat")
}

const handleCloseAIChat = () => {
  emit("closeAIChat")
}


// 是否是操作功能
const isSettingTool = ref(false)
// 选择文本
const handleClickChangeSelect = async (val) => {
  if (!currentIsCompleted.value) {
    return
  }
  isSettingTool.value = true
  chatText.value = val
  await handleClickSend(true)
  isSettingTool.value = false
  chatText.value = ""
}


const handleClickFixMistakes = async () => {
  if (!currentIsCompleted.value) {
    return
  }
  isSettingTool.value = true
  chatText.value = i18n.global.t('common.correct.all.error')
  await handleClickSend(true)
  isSettingTool.value = false
  chatText.value = ""
}


const handleClickChangeModel = () => {
  isSelectModel.value = !isSelectModel.value
  payload.value.model = isSelectModel.value ? 'deepseek-reasoner' : 'deepseek-chat'
  localStorage.setItem("AIChat", JSON.stringify(payload.value))
}


const isLoading = ref(false)
const pageNo = computed(() => store.state.AI.currentTargetSetting.pageNo)
const total = computed(() => store.state.AI.currentTargetSetting.total)
const pageSize = computed(() => store.state.AI.currentTargetSetting.pageSize)
// 滚动获取记录详情
const handleClickScroll = () => {
  // 滚动到底部自动开始 自动滚动
  const shouldAutoScroll = isAtBottom();
  if (shouldAutoScroll) {
    isUserScrolling.value = false
    return;
  }
  const {scrollTop, scrollHeight, clientHeight} = messageContainer.value;

  if (!messageContainer.value) return;
  if (!messageContainer.value || isLoading.value) return;
  // 如果用户未滚动到底部，认为是手动滚动
  isUserScrolling.value = scrollTop + clientHeight <= scrollHeight - 10;
  // 判断是否接近底部
  if (scrollHeight - scrollTop <= clientHeight + 50) {
    if (pageNo.value * pageSize.value <= total.value) {
      loadMoreData(); // 加载更多数据
    }
  }
}

const loadMoreData = async () => {
  isLoading.value = true
  await store.commit("AI/setCurrentTargetSetting", {type: "pageNo", value: pageNo.value + 1})
  await store.dispatch("AI/queryChatByIdApis", {
    associateId: handleTargetDetail.value.id,
    parentId: handleTargetDetail.value.parentId ? handleTargetDetail.value.parentId : '0'
  })
  const res = currentTargetChat.value.map(item => ({
    ...item,
    isCompletedAIChat: true,
    associateContent: item.associateContent.split('\n\n').join('\n\n>')
  }))
  await store.commit("AI/setChatContentArray", res)
  await store.commit("AI/setAssociateId", currentTargetChat.value[0].associateId)
}


/**
 * AI 停止对话
 */
const isStopSSe = ref(false)
const handleClickStop = async () => {
  console.log('stop')
  if (sseClient.value) {
    const target = chatContentArray.value[chatContentArray.value.length - 1]
    let targetChatItem = chatContentArray.value[chatContentArray.value.length - 1]

    const result = JSON.parse(localStorage.getItem("AIChat"));
    const messageId = localStorage.getItem("messageId")
    const parentIdRes = currentItem.value && currentItem.value.id ? currentItem.value.id : messageId
    if (currentItem.value !== null) {
      //   指定项重新生成
      targetChatItem = currentItem.value
    }
    const {content, associateContent, question, parentId} = targetChatItem
    let payload = {
      associateId: associateId.value,
      associateContent: associateContent ? associateContent : target.associateContent,
      content: content ? content : target.content,
      question: question,
      parentId: parentId,
    }
    if (currentItem.value !== null) {
      payload.parentId = parentIdRes
    }
    console.log(targetChatItem, currentItem.value, 'targetChatItem')
    if (payload.content === "" && payload.associateContent === "") {
      payload.content = " ";
      payload.associateContent = " ";
    }
    //   将最后一条断开的数据进行存储
    await store.dispatch("AI/closeAIApis", payload)
    // await store.commit("AI/setAssociateId", "")
    // 更新状态
    await store.dispatch("AI/getRootDataApis", {associateId: associateId.value})
    // payload = {parentId: parentId}
    // console.log(payload, 'payload')
    if (currentItem.value && currentItem.value.id) {
      console.log('=====1')
      // 如果是重新生成的内容则需要获取详情
      const resultPayload = chatContentArray.value.map(it => {
        if (it.id === currentLastNewChat.value.id) {
          return {
            ...it,
            question: result.message,
            isCompletedAIChat: false,
            currentTime: currentTime.value
          }
        } else {
          return it
        }
      })
      await store.commit("AI/setChatContentArray", resultPayload)
    } else {
      // 生成一条数据被中断 加载完成了
      if (chatContentArray.value[chatContentArray.value.length - 1].content !== '' || chatContentArray.value[chatContentArray.value.length - 1].associateContent !== '') {
        console.log('=====2', chatContentArray.value, currentLastNewChat.value.id, currentLastNewChat.value)
        console.log(chatContentArray.value)
        chatContentArray.value[chatContentArray.value.length - 1].isCompletedAIChat = false
        // 保证 id 一直为 根的id
        chatContentArray.value[chatContentArray.value.length - 1].id = currentLastNewChat.value.id
      } else {
        // 没有加载完成
        console.log('=====3', chatContentArray.value, currentLastNewChat.value.id, currentLastNewChat.value)
        chatContentArray.value.pop()
      }
    }


    const targetResult = chatContentArray.value.map(i => {
      if (i.id === currentLastNewChat.value.id) {
        // store.commit("AI/setCurrentPage", currentLastNewChat.value.childCount + 1)
        return {
          ...currentLastNewChat.value,
          associateContent: currentLastNewChat.value.associateContent.split('\n\n').join('\n\n>'),
          isCompletedAIChat: true,
          isDetail: true,
        }
      } else {
        return {...i}
      }
    })
    await store.commit("AI/setChatContentArray", targetResult)

    console.log(targetResult, 'targetResult')
    sseClient.value.pause(); // 断开 SSE
    sseClient.value.isCompleted = true; // 标记完成，防止重连
    isCompletedAIChat.value = true
    currentIsCompleted.value = true
    isStopSSe.value = true
  }
}


// 重启服务
// const handleClickRestart = () => {
//   if (sseClient.value) {
//     // chatContentArray.value[chatContentArray.value.length - 1].isCompletedAIChat = false
//     sseClient.value.resume("message", (data) => {
//       console.log("恢复后收到数据：", data);
//     });
//   }
// }

const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};

const toBuy = async () => {
  // 关闭AI
  await handleCloseAIChat()
  //   购买AI
  // const findTarget = allProductList.value.find(item => item.productSort === 4)
  // const {id, productSort} = findTarget
  // router.push({path: '/personal/buystorage', query: {indexId: id, productSort: productSort, type: 1}})
  openNewTab('/personal/aiDetails')
}


</script>
<style lang="less" scoped>
.ai-box {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;


  .ai-top {
    padding: 0px 20px;
    height: 56px;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0px 1px 6px 0px rgba(0, 21, 41, 0.12);

    .left {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }

    .right {
      display: flex;
      align-items: center;

      .img {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }

      .img {
        margin-right: 20px;
      }

      .img:nth-of-type(3) {
        margin-right: 0px;
      }
    }
  }

  .chat-content {
    flex: 1 1;
    width: 100%;
    background: #ffffff;
    overflow-y: scroll;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-content: space-between;
    padding: 30px 20px;
    position: relative;


  }

  .ai-tools {
    height: 92px;
    width: 100%;
    padding: 10px 20px 10px 20px;
    background: #F8F8F8;
    border-bottom: 1px solid #eaeaea;
    border-top: 1px solid #eaeaea;
  }

  .ai-text {
    height: 160px;
    padding: 12px;
    display: flex;
    font-size: 12px;
    flex-direction: column;
    background: #f8f8f8;

    .text {
      border-radius: 6px;
      border: 1px solid #EFEFEF;
      height: 90px;
      padding: 10px;
      overflow-y: scroll;
    }

    .btn {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
    }

    .btn > div:nth-of-type(1) {
      width: 80px;
      height: 32px;
      background: #1D39C4;
      border-radius: 2px;
      color: white;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
    }

    .btn > div:nth-of-type(2) {
      width: 93px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #1D39C4;
      color: #1D39C4;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
    }
  }
}

.btn-tool {
  width: 33%;
  height: 32px;
  background: #FFFFFF;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
  font-size: 14px;
}

.tag_img {
  width: 16px;
  height: 16px;
}

.btn-tool-sp {
  width: 32%;
  margin-left: 10px;
}

.btn-tool-sp:nth-of-type(1) {
  margin-left: 0px;
}

:deep(.el-select__wrapper) {
  box-shadow: none !important;
  border-radius: 40px !important;
}

.items-center {
  justify-content: center;
  align-items: center;
}

:deep(.el-select-dropdown__item) {
  height: max-content !important;
}

.ai-template-text {
  height: max-content;
  width: 100%;
  //padding: 10px 10px 10px 10px;
  //background: #F8F8F8;
  //border-bottom: 1px solid #eaeaea;
  //border-top: 1px solid #eaeaea;
  //float: left;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 每行两个 */
  gap: 10px; /* 网格间距 */
  padding: 10px;

  .btn-text {
    margin-top: 4px;
    width: auto;
    height: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    text-align: center;
    line-height: 20px;
    color: black;
    border: 1px solid transparent;
    margin-left: 4px !important;
    transition: all .3s;
    font-size: 12px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .btn-text:hover {
    border: 1px solid #2438bb;
  }

  .btn-text:active {
    background: #bfc7ff;
  }
}

.select_r1 {
  background: #cecdcd;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
  transition: all .3s;
}

.unselect_r1 {
  background: #FFFFFF;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
  transition: all .3s;
}

.select_r1_sp {
  background: #cecdcd;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
  transition: all .3s;
}

.select_r1_sp:hover {
  border: 1px solid #2438bb;
}

.unselect_r1_sp {
  background: #FFFFFF;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  color: black;
  border: 0px transparent;
  transition: all .3s;
  width: 125px !important;
}

.unselect_r1_sp:hover {
  border: 1px solid #2438bb;
}

.btn-text-ai {
  font-size: 13px !important;
  font-weight: 500;
  line-height: 30px;
}

.time {
  position: absolute;
  left: 50%;
  top: 15px;
  transform: translateX(-50%);
  font-size: 14px;
}

:deep(.el-button) {
  & > span {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>